import React from 'react'
import PropTypes from 'prop-types'

import MentionComponent from "../../../rich-editor/mentions/options/option-component/mention"

export default class MentionOptionComponent extends React.Component {

    static propTypes = {
        mention: PropTypes.object,
        viewType: PropTypes.oneOf(['edit','view'])
        //more may be passed by mentions plugin
    };

    static defaultProps = {
        viewType: 'edit'
    };

    constructor(props) {
        super(props);
        this.type = 'edit'; //['edit','view']
    }

    onClick = (e) => {
        e.stopPropagation();
        const enableLink = this.props.viewType === 'view' && [gd.const.editorLink.type.TASK,gd.const.editorLink.type.NOTE].includes(this.props.mention.type);
        if (!enableLink) return;

        switch (this.props.mention.type) {
            case gd.const.editorLink.type.TASK: gd.goTo('t/'+this.props.mention.data.id); break;
            case gd.const.editorLink.type.NOTE: gd.goTo('n/'+this.props.mention.data.id); break;
            case gd.const.editorLink.type.USER: gd.goTo('u/'+this.props.mention.data.id); break;
        }
    }

    onOpenNewWindow = (e) => {
        e.stopPropagation();
        const enableLink = this.props.viewType === 'view' && [gd.const.editorLink.type.TASK,gd.const.editorLink.type.NOTE].includes(this.props.mention.type);
        if (!enableLink) return;

        switch (this.props.mention.type) {
            case gd.const.editorLink.type.TASK: window.open('https://www.goodday.work/t/'+this.props.mention.data.id); break;
            case gd.const.editorLink.type.NOTE: window.open('https://www.goodday.work/n/'+this.props.mention.data.id); break;
            case gd.const.editorLink.type.USER: window.open('https://www.goodday.work/u/'+this.props.mention.data.id); break;
        }
    }

    render() {
        const classes = Classes("mention-option-component", this.props.className);
        const enableLink = this.props.viewType === 'view' && [gd.const.editorLink.type.TASK,gd.const.editorLink.type.NOTE].includes(this.props.mention.type);

        return (
            <div data-offset-key={this.props.children[0].key} className={classes} onClick={gd.viewMode === 'shared-view' ? this.onOpenNewWindow : this.onClick}>
                <MentionComponent mention={this.props.mention}/>
                {enableLink && <div className="mention-open-new-window i5-open-new-window" onClick={this.onOpenNewWindow}> </div>}
            </div>
        );
    }
}